import { useCreateBatchCallMutation } from '@/query/scheduler.query';

import type { BatchCallFormValues } from '@/schemas/batch-call.schema';

import { BatchCallDetailsForm } from './components/BatchCallDetailsForm';
import { RecipientsReview } from './components/ReviewRecipient';

import { BatchCallFormProvider } from '@/formik/batch-call.formik';

type CreateBatchCallProps = {
  onClose: () => void;
};

export default function CreateBatchCall({ onClose }: CreateBatchCallProps) {
  const { mutate: createBatchCall, isPending } = useCreateBatchCallMutation({
    onSuccess: () => {
      onClose();
    },
  });

  const handleSubmit = (values: BatchCallFormValues) => {
    createBatchCall(values);
  };

  return (
    <div className="w-full h-full overflow-auto">
      <BatchCallFormProvider onSubmit={handleSubmit}>
        <div className="flex flex-col items-center min-h-full bg-gradient-to-r from-white to-white p-5 pt-10 w-full overflow-y-auto">
          <div className="flex flex-col gap-6 items-center max-w-[1400px] w-full overflow-auto">
            {/* Header */}
            <div className="flex flex-col gap-1.5 items-start w-full">
              <div className="flex gap-2.5 items-center justify-center w-full">
                <h1 className="font-semibold text-lg text-zinc-950 flex-1">Create Batch Call</h1>
              </div>
              <div className="flex gap-2.5 items-center justify-center w-full">
                <p className="font-normal text-sm text-zinc-500 flex-1">
                  Upload recipients and schedule automated calls
                </p>
              </div>
            </div>

            {/* Two Column Layout */}
            <div className="grid grid-cols-[400px_1fr] gap-6 w-full">
              <BatchCallDetailsForm onCancel={onClose} isSubmitting={isPending} />
              <RecipientsReview />
            </div>
          </div>
        </div>
      </BatchCallFormProvider>
    </div>
  );
}
